var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPublisher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.666,64.333h-6.667v-17.333c0-.736-.597-1.333-1.333-1.333h-9.333v-9.333c0-.429-.206-.831-.554-1.082-.348-.251-.796-.319-1.201-.183l-15.578,5.193-15.578-5.193c-.408-.136-.854-.068-1.201,.183-.348,.251-.554,.653-.554,1.082v9.333h-9.333c-.736,0-1.333,.597-1.333,1.333v17.333h-6.667c-.736,0-1.333,.597-1.333,1.333v10.667c0,.736,.597,1.333,1.333,1.333h4v36c0,.737,.597,1.333,1.333,1.333h58.667c.736,0,1.333-.596,1.333-1.333v-36h4c.736,0,1.333-.597,1.333-1.333v-10.667c0-.736-.597-1.333-1.333-1.333h0Zm-20-10.294l-13.333,4.445v-15.857l13.333-4.445v15.857Zm-29.333-15.857l13.333,4.445v15.855l-13.333-4.445v-15.855Zm-10.667,10.151h8v6.667c0,.574,.367,1.083,.911,1.265l16,5.333h.008c.134,.045,.273,.068,.414,.068s.28-.023,.414-.067h.008l16-5.335c.544-.182,.911-.69,.911-1.265v-6.667h8v16H49.667v-16Zm6.667,64v-21.333h10.667v21.333h-10.667Zm46.667,0h-33.333v-22.667c0-.737-.597-1.333-1.333-1.333h-13.333c-.736,0-1.333,.596-1.333,1.333v22.667h-6.667v-34.667h56v34.667Zm5.333-37.333H41.667v-8H108.333v8Z",
    fill: "#47d5cd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103,99.25h-22c-.69,0-1.25-.56-1.25-1.25v-13.75c0-.69,.56-1.25,1.25-1.25h22c.69,0,1.25,.56,1.25,1.25s-.56,1.25-1.25,1.25h-20.75v11.25h20.75c.69,0,1.25,.56,1.25,1.25s-.56,1.25-1.25,1.25Z",
    fill: "#47d5cd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublisher);
export default __webpack_public_path__ + "static/media/publisher.7d28841e2ef226d8cbed6fd98c703887.svg";
export { ForwardRef as ReactComponent };